import React, { useState, useEffect } from 'react';
import './profilePage.css';
import {
  FaGraduationCap,
  FaScroll,
  FaCertificate,
  FaBriefcase,
  FaUsers,
  FaAward,
  FaChevronDown,

  FaChevronUp,
  FaRegEdit
} from 'react-icons/fa';
import profilePic from './dr_ember_wynn_placeholder.png';
import { get, put, post, del } from '../../../utility/fetch2';
import EditModal from './EditModal';
import AddModal from './AddModal';
import { toast } from 'react-hot-toast';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import ConfirmationModal from './ConfirmationModal';
import DeleteIcon from '@mui/icons-material/Delete';

const DEFAULT_DOC_PATH = 'https://cdn-icons-png.flaticon.com/512/942/942748.png';
const DEFAULT_DOC_NAME = 'defaultCert';


function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openAccordion, setOpenAccordion] = useState('education');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addingModalOpen, setAddingModalOpen] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [addingSection, setAddingSection] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [addValues, setAddValues] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletingSection, setDeletingSection] = useState(null);
  const [deletingItem, setDeletingItem] = useState(null);


  // Fetch profile data from API
  const getProfileDetails = async () => {
    setLoading(true);
    try {
      const res = await get(
        `/employeeaccount/list/employee/${sessionStorage.getItem('userId')}`
      );
      if (res.statusCode === 200) {
        setProfile(res?.data || {});
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeProfile = async () => {
      setLoading(true);
      try {
        const res = await get(
          `/employeeaccount/list/employee/${sessionStorage.getItem('userId')}`
        );
        if (res.statusCode === 200) {
          setProfile(res?.data || null);
        } else {
          setProfile(null);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        setProfile(null);
      } finally {
        setLoading(false);
      }
    };

    initializeProfile();
  }, []);

  // Accordion sections
  const sections = [
    {
      id: 'education',
      label: 'Education',
      icon: FaGraduationCap,
      hasContent: profile?.educations?.length > 0
    },
    {
      id: 'licenses',
      label: 'Licenses',
      icon: FaScroll,
      hasContent: profile?.licenses?.length > 0
    },
    {
      id: 'certifications',
      label: 'Certifications',
      icon: FaCertificate,
      hasContent: profile?.certificates?.length > 0
    },
    {
      id: 'work-experiences',
      label: 'Work Experiences',
      icon: FaBriefcase,
      hasContent: profile?.workExperiences?.length > 0
    },
    {
      id: 'associations',
      label: 'Associations',
      icon: FaUsers,
      hasContent: profile?.associations?.length > 0
    },
    {
      id: 'awards-recognition',
      label: 'Awards & Recognition',
      icon: FaAward,
      hasContent: profile?.awardAndRecognitions?.length > 0
    },
  ];

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  // Opens the docPath of a document object
  const handleViewDocument = (documentObj) => {
    if (documentObj?.docPath) {
      window.open(documentObj.docPath, '_blank');
    } else {
      alert('No document link provided.');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const handleEditClick = (e, section, item) => {
    e.stopPropagation();
    setEditingSection(section);
    setEditingItem(item);
    setEditValues(item);
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setEditingSection(null);
    setEditingItem(null);
    setEditValues({});
  };

  const handleEditChange = (name, value) => {
    setEditValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Update handleEditSubmit
  const handleEditSubmit = async () => {
    try {
      let endpoint = '';
      switch (editingSection) {
        case 'education':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-education/${editingItem.id}/update-employee-education`;
          break;
        case 'licenses':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-license/${editingItem.id}/update-employee-license`;
          break;
        case 'certifications':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-certificate/${editingItem.id}/update-employee-certificate`;
          break;
        case 'work-experiences':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-work-experience/${editingItem.id}/update-employee-work-experience`;
          break;
        case 'associations':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-association/${editingItem.id}/update-employee-association`;
          break;
        case 'awards-recognition':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-award-recognition/${editingItem.id}/update-employee-award`;
          break;
      }

      // Copy current edit values and add default document paths
      const payload = { ...editValues };

      // Add default documents based on section
      switch (editingSection) {
        case 'education':
          payload.employeeEducationCertificateDocument = {
            docName: DEFAULT_DOC_NAME,
            docPath: DEFAULT_DOC_PATH
          };
          break;
        case 'licenses':
          payload.employeeLicenseCertificateDocument = {
            docName: DEFAULT_DOC_NAME,
            docPath: DEFAULT_DOC_PATH
          };
          break;
        case 'certifications':
          payload.employeeCertificateDocument = {
            docName: DEFAULT_DOC_NAME,
            docPath: DEFAULT_DOC_PATH
          };
          break;
        case 'awards-recognition':
          payload.employeeAwardDocument = {
            docName: DEFAULT_DOC_NAME,
            docPath: DEFAULT_DOC_PATH
          };
          break;
      }

      const response = await put(endpoint, payload);
      if (response?.statusCode === 200) {
        toast.success('Updated successfully');
        await getProfileDetails();
        handleEditClose();
      } else {
        toast.error('Update failed');
      }
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Update failed');
    }
  };

  const handleDeleteClick = (e, section, item) => {
    e.stopPropagation();
    setDeletingSection(section);
    setDeletingItem(item);
    setDeleteModalOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteModalOpen(false);
    setDeletingSection(null);
    setDeletingItem(null);
  };


  const handleDeleteConfirm = async () => {
    try {
      let endpoint = '';
      switch (deletingSection) {
        case 'education':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-education/employeeeducation/${deletingItem.id}`;
          break;
        case 'licenses':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-license/employee-license/${deletingItem.id}`;
          break;
        case 'certifications':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-certificate/employee-certificate/${deletingItem.id}`;
          break;
        case 'work-experiences':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-work-experience/employee-work-experience/${deletingItem.id}`;
          break;
        case 'associations':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/employee-association/${deletingItem.id}/delete-employee-award-association`;
          break;
        case 'awards-recognition':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/employee-award-recognition/${deletingItem.id}/delete-employee-award-recognition`;
          break;
      }

      const response = await del(endpoint);
      if (response?.message) {
        toast.success('Deleted successfully');
        await getProfileDetails();
        handleDeleteClose();
      } else {
        toast.error('Delete failed');
      }
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Delete failed');
    }
  };

  const handleAddClick = (section) => {
    setAddingSection(section);
    setAddValues({});
    setAddingModalOpen(true);
  };

  const handleAddClose = () => {
    setAddingModalOpen(false);
    setAddingSection(null);
    setAddValues({});
  };

  const handleAddChange = (name, value) => {
    setAddValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Add this constant at the top with other constants
  const DEFAULT_DOC_PATH = 'https://cdn-icons-png.flaticon.com/512/942/942748.png';
  const DEFAULT_DOC_NAME = 'defaultCert';

  // Add this new function to handle initial profile creation
  const createInitialProfile = async (section, entries) => {
    try {
      const payload = {
        licenseNumber: "TMP" + Date.now(), // Temporary license number
        dateOfLicense: new Date().toISOString(),
        licenseCertificateDocument: {
          docName: DEFAULT_DOC_NAME,
          docPath: DEFAULT_DOC_PATH
        },
        certificationIsValid: true,
        educations: [],
        licenses: [],
        certificates: [],
        workExperiences: [],
        associations: [],
        awardAndRecognitions: [],
        employeeId: sessionStorage.getItem('userId')
      };

      // Add the entries to the appropriate section
      switch (section) {
        case 'education':
          payload.educations = entries.map(entry => ({
            ...entry,
            employeeEducationCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'licenses':
          payload.licenses = entries.map(entry => ({
            ...entry,
            employeeLicenseCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'certifications':
          payload.certificates = entries.map(entry => ({
            ...entry,
            employeeLicenseCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'work-experiences':
          payload.workExperiences = entries;
          break;
        case 'associations':
          payload.associations = entries;
          break;
        case 'awards-recognition':
          payload.awardAndRecognitions = entries.map(entry => ({
            ...entry,
            employeeAwardDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
      }

      const response = await post('/employeeaccount/create-employee-account', payload);
      return response;
    } catch (error) {
      console.error('Error creating profile:', error);
      throw error;
    }
  };

  // Update handleAddSubmit to handle both initial creation and adding to existing profile
  const handleAddSubmit = async (entries) => {
    try {
      if (!profile) {
        // Create initial profile with the first section
        const response = await createInitialProfile(addingSection, entries);
        if (response?.statusCode === 200) {
          toast.success('Profile created successfully');
          await getProfileDetails(); // Fetch the newly created profile
          handleAddClose();
        } else {
          toast.error('Failed to create profile');
        }
      } else {
        // Use existing add endpoint logic for subsequent additions
        let endpoint = '';
        const userId = sessionStorage.getItem('userId');

        switch (addingSection) {
          case 'education':
            endpoint = `/employeeaccount/employeeeducations/${profile.id}/employee/${userId}`;
            break;
          case 'licenses':
            endpoint = `/employeeaccount/employee-licenses/${profile?.id}/employee/${userId}`;
            break;
          case 'certifications':
            endpoint = `/employeeaccount/add-add-employee-certificates/${profile?.id}/employee/${userId}`;
            break;
          case 'work-experiences':
            endpoint = `/employeeaccount/add-employee-work-experiences/${profile?.id}/employee/${userId}`;
            break;
          case 'associations':
            endpoint = `/employeeaccount/${profile?.id}/employee/${userId}/add-employee-associations`;
            break;
          case 'awards-recognition':
            endpoint = `/employeeaccount/${profile?.id}/employee/${userId}/add-employee-awards-recognitions`;
            break;
        }

        // Process entries and add default documents
        const processedEntries = entries.map(entry => {
          const processedEntry = { ...entry };
          switch (addingSection) {
            case 'education':
              processedEntry.employeeEducationCertificateDocument = {
                docName: DEFAULT_DOC_NAME,
                docPath: DEFAULT_DOC_PATH
              };
              break;
            case 'licenses':
              processedEntry.employeeLicenseCertificateDocument = {
                docName: DEFAULT_DOC_NAME,
                docPath: DEFAULT_DOC_PATH
              };
              break;
            case 'certifications':
              processedEntry.employeeCertificateDocument = {
                docName: DEFAULT_DOC_NAME,
                docPath: DEFAULT_DOC_PATH
              };
              break;
            case 'awards-recognition':
              processedEntry.employeeAwardDocument = {
                docName: DEFAULT_DOC_NAME,
                docPath: DEFAULT_DOC_PATH
              };
              break;
          }
          return processedEntry;
        });

        const response = await post(endpoint, processedEntries);
        if (response?.statusCode === 200) {
          toast.success('Added successfully');
          await getProfileDetails();
          handleAddClose();
        } else {
          toast.error('Failed to add');
        }
      }
    } catch (error) {
      console.error('Error adding:', error);
      toast.error('Failed to add');
    }
  };

  const renderSectionHeader = (title, section) => (
    <div className="profile-accordion__section-header m-b-20">
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="primary"
        size="small"
        onClick={() => handleAddClick(section)}
        sx={{ ml: 2 }}
      >
        Add New {section}
      </Button>
    </div>
  );

  const renderSectionContent = (id) => {
    // if (!profile) return null;

    switch (id) {
      case 'education':
        return (
          <>
            {renderSectionHeader('Education', 'education')}
            {profile?.educations?.map((entry) => (
              <div key={entry.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{entry.fieldOdStudy}</div>
                  <div className="profile-education__institution">{entry.institutionName}</div>
                  <div className="profile-education__years">
                    {formatDate(entry.startDate)} – {formatDate(entry.endDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(entry.employeeEducationCertificateDocument)
                    }
                  >
                    View certificate
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'education', entry)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'education', entry)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'licenses':
        return (
          <>
            {renderSectionHeader('Licenses', 'licenses')}
            {profile?.licenses?.map((license) => (
              <div key={license.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{license.titleOfLicense}</div>
                  <div className="profile-education__institution">
                    {license.issuingOrganization}
                  </div>
                  <div className="profile-education__country">{license.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(license.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(license.employeeLicenseCertificateDocument)
                    }
                  >
                    View License
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'licenses', license)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'licenses', license)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'certifications':
        return (
          <>
            {renderSectionHeader('Certifications', 'certifications')}
            {profile?.certificates?.map((cert) => (
              <div key={cert.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{cert.titleOfCertification}</div>
                  <div className="profile-education__institution">{cert.issuingOrganization}</div>
                  <div className="profile-education__country">{cert.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(cert.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(cert.employeeCertificateDocument)
                    }
                  >
                    View Certificate
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'certifications', cert)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'certifications', cert)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'work-experiences':
        return (
          <>
            {renderSectionHeader('Work Experiences', 'work-experiences')}
            {profile?.workExperiences?.map((exp) => (
              <div key={exp.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{exp.designation}</div>
                  <div className="profile-education__institution">
                    {exp.organizationName}
                  </div>
                  <div className="profile-education__country">{exp.nationality.name}</div>
                  <div className="profile-education__years">
                    {formatDate(exp.startDate)} – {formatDate(exp.endDate)}
                  </div>
                  <div className="profile-education__description">{exp.jobDescription}</div>
                </div>
                <div className="profile-education__actions">
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'work-experiences', exp)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'work-experiences', exp)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>

              </div>
            ))}
          </>
        );

      case 'associations':
        return (
          <>
            {renderSectionHeader('Associations', 'associations')}
            {profile?.associations?.map((assoc) => (
              <div key={assoc.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{assoc.associationName}</div>
                  <div className="profile-education__institution">
                    Member Type: {assoc.memberType}
                  </div>
                  <div className="profile-education__country">{assoc.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(assoc.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'associations', assoc)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'associations', assoc)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'awards-recognition':
        return (
          <>
            {renderSectionHeader('Awards & Recognition', 'awards-recognition')}
            {profile?.awardAndRecognitions?.map((award) => (
              <div key={award.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{award.title}</div>
                  <div className="profile-education__institution">
                    {award.issuingOrganization}
                  </div>
                  <div className="profile-education__country">{award.nationality.name}</div>
                  <div className="profile-education__years">
                    Awarded: {formatDate(award.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() => handleViewDocument(award.employeeAwardDocument)}
                  >
                    View Award
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'awards-recognition', award)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'awards-recognition', award)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return <div className="profile-page__loading">Loading...</div>;
  }

  return (
    <>
      <div className="profile-page__container w-100 main-content">
        <div className="profile-top-header">
          <div className="profile-top-header__profile-info">
            <img
              src={profilePic}
              alt="Profile"
              className="profile-top-header__profile-pic"
            />
            <div className="profile-top-header__text-info">
              <span className="profile-top-header__name">
                {profile?.employee?.firstName} {profile?.employee?.lastName}
              </span>
            </div>
          </div>
        </div>

        <div className="profile-page__body-wrapper w-100">
          <main className="profile-main-content-accordion w-100">
            <h2 className="profile-main-content-accordion__title">Profile Setup</h2>
            <p className="profile-main-content-accordion__instruction">
              Please provide the following information to get started!
            </p>

            <div className="profile-accordion-container w-100">
              {sections.map((section) => (
                <div key={section.id} className="profile-accordion__item">
                  <div
                    className={`profile-accordion__header ${openAccordion === section.id
                      ? 'profile-accordion__header--open'
                      : ''
                      }`}
                    onClick={() => toggleAccordion(section.id)}
                  >
                    <div className="profile-accordion__header-left">
                      <section.icon className="profile-accordion__icon" />
                      <span className="profile-accordion__label">{section.label}</span>
                    </div>
                    {openAccordion === section.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {openAccordion === section.id && (
                    <div className="profile-accordion__content">
                      {renderSectionContent(section.id)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>

      <EditModal
        open={editModalOpen}
        onClose={handleEditClose}
        title={`Edit ${editingSection
          ?.split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}`}
        fields={getFieldsForSection(editingSection)}
        values={editValues}
        onChange={handleEditChange}
        onSubmit={handleEditSubmit}
      />

      <AddModal
        open={addingModalOpen}
        onClose={handleAddClose}
        title={`Add ${addingSection?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`}
        fields={getFieldsForSection(addingSection)}
        values={addValues}
        onChange={handleAddChange}
        onSubmit={handleAddSubmit}
      />

      <ConfirmationModal
        open={deleteModalOpen}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
        title="Confirm Delete"
        message={`Are you sure you want to delete this ${deletingSection?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} record?`}
      />
    </>
  );
}

// Define fields for each section’s EditModal
const getFieldsForSection = (section) => {
  switch (section) {
    case 'education':
      return [
        { name: 'institutionName', label: 'Institution Name' },
        { name: 'fieldOdStudy', label: 'Field of Study' },
        { name: 'startDate', label: 'Start Date', type: 'date' },
        { name: 'endDate', label: 'End Date', type: 'date' }
      ];

    case 'licenses':
      return [
        { name: 'titleOfLicense', label: 'Title of License' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: [{ value: 19, label: 'Nigerian' }]
        }
      ];

    case 'certifications':
      return [
        { name: 'titleOfCertification', label: 'Title of Certification' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: [{ value: 19, label: 'Nigerian' }]
        }
      ];

    case 'work-experiences':
      return [
        { name: 'organizationName', label: 'Organization Name' },
        { name: 'designation', label: 'Designation' },
        { name: 'startDate', label: 'Start Date', type: 'date' },
        { name: 'endDate', label: 'End Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: [{ value: 19, label: 'Nigerian' }]
        },
        { name: 'jobDescription', label: 'Job Description', multiline: true }
      ];

    case 'associations':
      return [
        { name: 'associationName', label: 'Association Name' },
        { name: 'memberType', label: 'Member Type' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: [{ value: 19, label: 'Nigerian' }]
        }
      ];

    case 'awards-recognition':
      return [
        { name: 'title', label: 'Award Title' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Date Awarded', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: [{ value: 19, label: 'Nigerian' }]
        }
      ];

    default:
      return [];
  }
};

export default ProfilePage;
